/**
 * @module components/footer
 *
 * The site footer is authored in HTML for search engines and no-JS readers, so
 * this module only does the two things markup cannot: inject the inline logo
 * mark and stamp the current year.
 */

import { qs } from "../core/dom.js";
import { logoLockup } from "../svg/logo.js";

/**
 * @returns {() => void} Teardown.
 */
export function initFooter() {
  const brand = qs("[data-footer-brand]");
  if (brand && !brand.querySelector(".logo")) {
    brand.innerHTML = logoLockup({ variant: "footer", size: 30 });
  }

  const year = qs("[data-year]");
  if (year) {
    year.textContent = String(new Date().getFullYear());
  }

  return () => {};
}
